import { render, staticRenderFns } from "./RegistrationSubmitted.vue?vue&type=template&id=2a35dbc7&scoped=true&"
import script from "./RegistrationSubmitted.vue?vue&type=script&lang=js&"
export * from "./RegistrationSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSubmitted.vue?vue&type=style&index=0&id=2a35dbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35dbc7",
  null
  
)

export default component.exports